import './exportable_chart.js.coffee';# Added by Script 
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.PositiveVsNegativeView extends Monitoring.Reports.Campaign.ExportableChart
  include @, Monitoring.Reports.Campaign.Utils

  className: 'positive-vs-negative'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass('processing')

    params = @paramsForChildsOfPosts
      dimension: 'sentiment'
      exclude_page_owner_generated: true

    $.post('/monitoring/api/charts/single_dimension', params, @_renderChart)

  _renderChart: (data) =>
    @$el.removeClass('processing')

    @series = {}
    for data in data.series[0].data
      @series[data.code] = data.y
    
    @_renderPie()
    
    @trigger('rendered')

  _renderPie: ->
    @$el.highcharts({
      chart:
        type: 'pie'
        backgroundColor: "#FFFFFF"
        height: 400
        style: {fontFamily: "Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"}
      title: null
      plotOptions:
        pie:
          dataLabels:
            enabled: false
          showInLegend: true
          borderColor: null
      legend:
        labelFormat: '{name} - {y} ({percentage:.2f}%)'
      exporting:
        enabled: true
        chartOptions:
          title: null 
      series: [
        {
          name: 'Sentiment'
          data: [
            {
              name: I18n.t('monitoring.dashboard.charts.negative')
              color: @options.colors.negative
              y: @series.negative
            }
            {
              name: I18n.t('monitoring.dashboard.charts.positive')
              color: @options.colors.positive
              y: @series.positive
            }
          ]
        }
      ]
    })